import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  contactSupport: {
    id: 'learning.goals.unsubscribe.contact',
    defaultMessage: 'contact support',
  },
  description: {
    id: 'learning.goals.unsubscribe.description',
    defaultMessage: 'You will no longer receive email reminders about your goal for {courseTitle}.',
  },
  errorHeader: {
    id: 'learning.goals.unsubscribe.errorHeader',
    defaultMessage: 'Something went wrong',
  },
  goToDashboard: {
    id: 'learning.goals.unsubscribe.goToDashboard',
    defaultMessage: 'Go to dashboard',
  },
  header: {
    id: 'learning.goals.unsubscribe.header',
    defaultMessage: 'You’ve unsubscribed from goal reminders',
  },
  loading: {
    id: 'learning.goals.unsubscribe.loading',
    defaultMessage: 'Unsubscribing…',
  },
});

export default messages;
